export const systemIt = {
  // LegalPage
  'system.legal.fallbackTitle': 'Documento',
  'system.legal.fallbackBody': 'Non trovato.',
  'system.legal.lastUpdated': 'Ultimo aggiornamento {date}',

  // NotFoundPage
  'system.notFound.seoTitle': 'Perduto nel Velo',
  'system.notFound.heading': 'Hai vagato oltre il margine della mappa',
  'system.notFound.body': 'Il sentiero che cercavi è stato inghiottito dal crepuscolo eterno.',
  'system.notFound.returnCta': 'Torna al Velo',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'Un disturbo ignoto ha scosso il velo.',
  'system.error.seoTitle': 'Un Turbamento nel Velo',
  'system.error.heading': 'Il rituale ha fallito',
  'system.error.body':
    'Qualcosa di invisibile ha interrotto questa pagina. Il velo è sottile qui — riprova, o torna su terreni più sicuri.',
  'system.error.tryAgain': 'Riprova',
  'system.error.returnCta': 'Torna al Velo',
  'licenseGate.heading': "Presto disponibile — limitato da licenza",
  'licenseGate.body': "Questa edizione linguistica non è ancora disponibile per motivi di licenza. È in arrivo — torna presto.",
} as const
